export default __webpack_public_path__ + "static/media/3 (1).f01cc973.jpg";